import axios from "axios";
import { ApiUrl, NestURL } from "../../../utils/Network";
import {
  ChangeRolePlayerForm,
  ConversationsType,
  CreateUpdateGroupChannelType,
} from "../types";

export const fetchAllChats = (limit: number, skip: number) => {
  return axios.get(
    `${NestURL}/conversation/all/?limit=${limit}&skip=${skip * limit}`,
    {
      data: {},
      withCredentials: false,
    }
  );
};

export const fetchProfilePlayerById = (id: string) => {
  return axios.get(`${ApiUrl}/player/profile?playerId=${id}`);
};

export const fetchUserMetaData = (id: number) => {
  return axios.get(`${ApiUrl}/player/summury?playerid=${id}`);
};

export const fetchPersonalMessages = (
  userId: number,
  chatId: string,
  page: number
) => {
  return axios.get(
    `${NestURL}/message/chat?chatId=${chatId}&userId=${userId}&skip=${
      page * 50
    }&limit=50`,
    {
      data: {},
      withCredentials: false,
    }
  );
};

export const fetchPlayers = (filter: string, count: number, page: number) => {
  return axios.get(
    `${ApiUrl}/player/getlist/?filter=${filter}&count=${count}&page=${page}`
  );
};

export const fetchMembers = (
  conversationId: string,
  count: number,
  page: number
) => {
  return axios.get(
    `${NestURL}/conversation/${conversationId}/members/?skip=${
      page * 10
    }&limit=${count}`,
    {
      data: {},
      withCredentials: false,
    }
  );
};

export const fetchGroupChannelMessages = (
  conversationId: string,
  page: number
) => {
  return axios.get(
    `${NestURL}/message/chat?conversationId=${conversationId}&skip=${
      page * 50
    }&limit=50`,
    {
      data: {},
      withCredentials: false,
    }
  );
};

export const fetchGroupChannel = (
  name: string,
  count: number,
  page: number,
  type?: ConversationsType
) => {
  const typeParam = type ? `&type=${type}` : "";
  const url = `${NestURL}/conversation/explore/?name=${name}${typeParam}&skip=${
    page * count
  }&limit=${count}`;
  return axios.get(url, {
    data: {},
    withCredentials: false,
  });
};

export const removeConversation = (conversationId: string) => {
  return axios.delete(`${NestURL}/conversation/${conversationId}`, {
    withCredentials: false,
    data: {},
  });
};

export const ejectMember = (conversationId: string, memberId: number) => {
  return axios.delete(`${NestURL}/conversation/${conversationId}/kick`, {
    withCredentials: false,
    data: {
      memberId,
    },
  });
};

export const leftConversation = (conversationId: string) => {
  return axios.delete(`${NestURL}/conversation/${conversationId}/leave`, {
    withCredentials: false,
    data: {},
  });
};

export const removeMessage = (conversationId: string, messageId: string) => {
  return axios.delete(`${NestURL}/conversation/${conversationId}/message`, {
    withCredentials: false,
    data: {
      messageId,
    },
  });
};

export const subscribeInConversation = (conversationId: string) => {
  return axios.put(
    `${NestURL}/conversation/${conversationId}/add-me`,
    {
      data: {},
    },
    {
      withCredentials: false,
    }
  );
};

export const requestCreateGrpChnl = (
  formValues: CreateUpdateGroupChannelType
) => {
  const { type, ...data } = formValues;
  return axios.post(
    `${NestURL}/conversation/create-${type}`,
    {
      ...data,
    },
    {
      withCredentials: false,
    }
  );
};

export const requestUpdateGrpChnl = (
  conversationId: string,
  formValues: CreateUpdateGroupChannelType
) => {
  const { type, ...data } = formValues;
  return axios.patch(
    `${NestURL}/conversation/${conversationId}`,
    {
      ...data,
    },
    {
      withCredentials: false,
    }
  );
};

export const requestChangeRolePlayer = (
  conversationId: string,
  data: ChangeRolePlayerForm
) => {
  return axios.post(
    `${NestURL}/conversation/roles/${conversationId}`,
    {
      ...data,
    },
    {
      withCredentials: false,
    }
  );
};

export const fetchMembershipUserIdInConversation = (
  conversationId: string,
  userId: string
) => {
  return axios.get(
    `${NestURL}/conversation/${conversationId}/membership/?userId=${userId}`,
    {
      data: {},
      withCredentials: false,
    }
  );
};

export const muteUserFromConversation = (
  conversationId: string,
  userId: number
) => {
  return axios.put(
    `${NestURL}/conversation/${conversationId}/mute`,
    {
      userId,
    },
    {
      withCredentials: false,
    }
  );
};

export const unMuteUserFromConversation = (
  conversationId: string,
  userId: number
) => {
  return axios.put(
    `${NestURL}/conversation/${conversationId}/unmute`,
    {
      userId,
    },
    {
      withCredentials: false,
    }
  );
};

export const fetchGroupByExternalId = (externalId: number) => {
  return axios.get(
    `${NestURL}/conversation/get-group-admin/?external_id=${externalId}`,
    {
      data: {},
      withCredentials: false,
    }
  );
};

export const fetchMessageTrasnlateById = (messageId: string, lang: string) => {
  return axios.get(
    `${NestURL}/message/translate/?messageId=${messageId}&lang=${encodeURIComponent(lang)}`,
    {
      data: {},
      withCredentials: false,
    }
  );
};
